<template>
  <div
    :id="`service-${serviceId}`"
    class="page-service page"
    :class="{ 'empty': serviceIsNotAvaliable }"
  >
    <p
      v-if="false"
      class="bread-crumbs"
    >
      <nuxt-link :to="{name: 'index-id', params: {id: category}, hash: '#tab'}">
        {{ categoryName }}
      </nuxt-link>
      <i class="icon-chevron-right" />
      <span>{{ serviceName }}</span>
    </p>
    <template v-if="serviceIsNotAvaliable">
      <ServiceNotAvaliable />
    </template>
    <template v-else>
      <h1 v-show="serviceName">
        {{ serviceName }}
      </h1>
      <div
        class="page"
        :class="{
          'has-side': !redirection,
          'has-banner': bannerList.length > 0
        }"
      >
        <v-progress-circular
          v-if="redirection === null"
          indeterminate
          color="primary"
        />
        <main v-show="redirection !== null">
          <div
            v-if="bannerList.length"
            ref="bannerSwiper"
            v-swiper:bannerSwiper="bannerSliderOptions"
            class="banner-swiper banner-list"
          >
            <div class="swiper-wrapper">
              <div
                v-for="(banner, index) in bannerList"
                :key="index"
                class="swiper-slide banner"
              >
                <img
                  class="banner-swiper__image"
                  :src="banner"
                  :alt="`${serviceName}-${serviceDetails.service_desc}`"
                >
              </div>
            </div>
          </div>
          <div
            v-else
            class="banner-list"
          >
            <div class="banner">
              <img
                src="@/assets/image/serviceIntro/intro-banner-default.png"
                alt="服務banner"
              >
            </div>
          </div>
          <div
            id="service-tab"
            class="tabs"
          >
            <v-tabs
              class="fixed-tabs-bar"
              grow
              :hide-slider="true"
            >
              <template v-if="!redirection">
                <v-tab
                  class="tab service-tab"
                  :to="{
                    name: tabs[0].routeName,
                    params: {
                      ...params,
                      noScroll: true
                    }
                  }"
                  replace
                  exact
                  @click="scrollToTab(tabs[0])"
                >
                  {{ tabs[0].label }}
                </v-tab>
                <v-tab
                  class="tab service-tab"
                  :to="{
                    name: tabs[1].routeName,
                    params: {
                      ...params,
                      noScroll: true
                    }
                  }"
                  replace
                  exact
                  @click="scrollToTab(tabs[1])"
                >
                  {{ tabs[1].label }}
                </v-tab>
                <v-tab
                  class="tab service-tab"
                  :to="{
                    name: tabs[2].routeName,
                    params: {
                      ...params,
                      noScroll: true
                    }
                  }"
                  replace
                  exact
                  @click="scrollToTab(tabs[1])"
                >
                  {{ tabs[2].label }}
                  <v-chip
                    v-if="service && service.ServiceScores"
                    small
                    color="#efeff4"
                  >
                    {{ transformScoreAmount(service.ServiceScores.totalCount) }}
                  </v-chip>
                </v-tab>
                <v-tab
                  class="tab service-tab"
                  :to="{
                    name: tabs[3].routeName,
                    params: {
                      ...params,
                      noScroll: true
                    }
                  }"
                  replace
                  exact
                  @click="scrollToTab(tabs[3])"
                >
                  {{ tabs[3].label }}
                </v-tab>
              </template>
              <v-tabs-items class="tab-content">
                <keep-alive>
                  <NuxtChild
                    :is-community="isCommunity"
                    :redirection="redirection"
                    :service-main-url="serviceMainUrl"
                  />
                </keep-alive>
              </v-tabs-items>
            </v-tabs>
          </div>
        </main>
        <template v-if="isCommunity">
          <div
            v-if="!communityLoadDone"
            class="loading side"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </div>
          <client-only v-else-if="communitySideNoteShow">
            <group-service-side-note
              ref="groupServiceSideNote"
              class="side"
              :step="communitySideNoteShow"
            />
          </client-only>
          <group-service-items
            v-else
            ref="groupServiceItem"
            :key="serviceItemId"
            class="side"
            :service-id="serviceId"
            :is-community="isCommunity"
            :community-list="communityList"
            @setOrderIsComplete="setOrderIsComplete"
            @refreshData="refreshServiceItem"
          />
        </template>
        <group-service-items
          v-else-if="!redirection"
          ref="groupServiceItem"
          :key="serviceItemId"
          class="side"
          :service-id="serviceId"
          @setOrderIsComplete="setOrderIsComplete"
          @refreshData="refreshServiceItem"
        />
      </div>
      <v-btn
        v-if="isMobile"
        v-show="!isCommunity || (isCommunity && !communitySideNoteShow)"
        depressed
        tile
        color="primary"
        class="footer-btn"
        :class="{
          'show': footerShow
        }"
        @click="clickFooterBtn"
      >
        {{ isProductMode ? '立即訂購' : '立即預約' }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import mixiSserviceSSR from '@/mixin/serviceSSR'
import ServiceNotAvaliable from '@/components/Error/ServiceNotAvaliable.vue'
import GroupServiceItems from '@/components/GroupServiceItems.vue'
import GroupServiceSideNote from '@/components/GroupServiceSideNote.vue'
export default {
  auth: false,
  components: {
    GroupServiceItems,
    GroupServiceSideNote,
    ServiceNotAvaliable
  },
  mixins: [mixiSserviceSSR],
  beforeRouteLeave (to, from, next) {
    const goMemberUpgrade = sessionStorage.getItem('memberUpgradeSaveRoute')
    const canGoNext = () => {
      return (
        this.communitySideNoteShow ||
        to.name === 'login' ||
        this.orderIsComplete ||
        this.redirection ||
        this.serviceIsNotAvaliable ||
        goMemberUpgrade
      )
    }
    if (to.name === 'login') {
      this.loginSaveDataHandler()
    }
    if (canGoNext()) {
      this.$store.commit('service/clearServiceData', { id: this.serviceId })
      this.removeListenTabSticky()
      next()
      return
    }
    this.$alert({
      title: '系統提示',
      // message: '您尚未填寫完成，離開此頁資料將不會儲存，確定要離開嗎？',
      message: '訂購尚未完成，離開此頁訂購資料將不會儲存，確定要離開嗎？',
      persistent: true,
      btn: [
        {
          btnText: '取消',
          btnClick: () => {
            this.$alert.close()
          }
        },
        {
          btnText: '確定',
          btnColor: 'primary',
          btnClick: () => {
            this.removeListenTabSticky()
            this.$store.commit('service/clearServiceData', { id: this.serviceId })
            this.$store.commit('clearGeustPurchaseData')
            this.$store.commit('clearGeustPurchaseOrderStatus')
            this.$alert.close()
            next()
          }
        }
      ]
    })
  },
  data () {
    return {
      serviceId: null,
      serviceName: null,
      category: null,
      categoryName: null,
      image: null,
      isOpen: null,
      serviceMainUrl: null,
      keywords: null,
      metaTitle: null,
      isMobile: null,
      tabs: [
        {
          label: '服務介紹',
          routeName: 'category-category-service'
        },
        {
          label: '價格方案',
          routeName: 'category-category-service-price'
        },
        {
          label: '評價',
          routeName: 'category-category-service-comment'
        },
        {
          label: '注意事項',
          routeName: 'category-category-service-notes'
        }
      ],
      footerShow: true,
      communitySideNoteShow: false,
      communityLoadDone: false,
      communityList: [],
      redirection: null,
      orderIsComplete: false,
      serviceItemId: 1,
      observer: null,
      bannerSliderOptions: {
        loop: false,
        watchOverflow: true,
        touchEventsTarget: 'wrapper',
        preloadImages: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        slidesPerView: 'auto'
      }
    }
  },
  head () {
    return {
      title: this.metaTitle,
      meta: [
        { hid: 'title', name: 'title', content: this.metaTitle + this.$store.state.meta.titleTemple },
        { hid: 'description', name: 'description', content: this.description },
        { hid: 'keywords', name: 'keywords', content: this.keywords },
        { hid: 'og:url', property: 'og:url', content: this.webBaseUrl + this.routeFullPath },
        { hid: 'og:title', property: 'og:title', content: this.metaTitle + this.$store.state.meta.titleTemple },
        { hid: 'og:description', property: 'og:description', content: this.description },
        this.image ? { hid: 'og:image', property: 'og:image', content: this.image } : {},
        { hid: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
        { hid: 'twitter:url', property: 'twitter:url', content: this.webBaseUrl + this.routeFullPath },
        { hid: 'twitter:title', property: 'twitter:title', content: this.metaTitle + this.$store.state.meta.titleTemple },
        { hid: 'twitter:description', property: 'twitter:description', content: this.description },
        this.image ? { hid: 'twitter:image', property: 'twitter:image', content: this.image } : {},
        { hid: 'robots', name: 'robots', content: this.isOpen && this.$nuxt.context.env.NODE_ENV_NAME === 'ec' ? 'all' : 'noindex' },
        { hid: 'googlebot', name: 'googlebot', content: this.isOpen && this.$nuxt.context.env.NODE_ENV_NAME === 'ec' ? 'all' : 'noindex' },
      ]
    }
  },
  meta: {
    banner: false
  },
  jsonld () {
    if (this.redirection) return null // 導購制服務不需提供結構化資料
    const baseUrl = String(this.$nuxt.context.env.BASE_WEB_URL || ' ').slice(0, -1)
    const serviceRouteData = this.$nuxt.$router.resolve({
      name: 'category-category-service',
      params: {
        service: this.serviceId,
        category: this.category
      }
    })
    const currentServiceUrl = baseUrl + serviceRouteData.resolved.fullPath
    const getBreadcrumbList = () => {
      const categoryRoute = this.$nuxt.$router.resolve({
        name: 'index-id',
        params: {
          id: this.category
        }
      })
      const categoryUrl = baseUrl + categoryRoute.resolved.fullPath
      return [
        {
          '@type': 'ListItem',
          position: 1,
          name: this.$store.state.meta.title,
          item: baseUrl
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: this.categoryName,
          item: categoryUrl
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: this.metaTitle,
          item: currentServiceUrl
        }
      ]
    }
    const getPriceOptionGroup = () => {
      const servicePriceOptionGroup = _.cloneDeep(this.$store.state.service.serviceData?.[this.serviceId]?.ServicePriceOptionGroup)
      if (!servicePriceOptionGroup?.length) return {}
      const priceOptionGroup = []
      servicePriceOptionGroup.forEach(priceOption => {
        priceOption.price_option.forEach(option => {
          const optionObject = {
            '@type': 'Offer',
            priceCurrency: 'TWD',
            price: option.price,
            name: option.price_name,
            availability: 'https://schema.org/InStock',
            priceValidUntil: '2099-01-01',
            url: currentServiceUrl
            // itemOffered: []
          }
          if (optionObject?.Images?.length) {
            optionObject.image = optionObject?.Images.map(image => image.ImageUri)
          }
          priceOptionGroup.push(optionObject)
        })
      })
      return {
        offers: priceOptionGroup
      }
    }
    const getRating = () => {
      const serviceScores = _.cloneDeep(this.$store.state.service.serviceData?.[this.serviceId]?.ServiceScores)
      if (!serviceScores?.totalCount) return {}
      return {
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: serviceScores.avgScore,
          reviewCount: serviceScores.totalCount
        }
      }
    }
    return {
      '@context': 'http://schema.org',
      '@graph': [
        {
          '@type': 'BreadcrumbList',
          itemListElement: getBreadcrumbList()
        },
        {
          '@type': 'Product',
          name: this.metaTitle,
          category: this.categoryName,
          image: this.$store.getters['service/getBannerList'](this.serviceId),
          description: this.description,
          sku: '',
          brand: {
            '@type': 'Brand',
            name: '智樂家'
          },
          ...getPriceOptionGroup(),
          ...getRating()
        }
      ]
    }
  },
  computed: {
    serviceIsNotAvaliable () {
      return this.service?.is_check !== 1
    },
    service () {
      return this.$store.state.service.serviceData[parseInt(this.serviceId)]
    },
    bannerList () {
      return this.$store.getters['service/getBannerList'](this.serviceId)
    },
    params () {
      return {
        service: this.serviceId,
        serviceName: this.serviceName,
        category: this.category,
        categoryName: this.categoryName
      }
    },
    isCommunity () { // 社區模式
      if (!this.$store.state.service.serviceData[parseInt(this.serviceId)]) return null
      if (!this.$store.state.service.serviceData[parseInt(this.serviceId)].serviceAddressMode) return null
      return this.$store.state.service.serviceData[parseInt(this.serviceId)].serviceAddressMode.id === 2
    },
    cityList () {
      return this.$store.getters['service/regionList'](this.serviceId)
    },
    typeId () {
      return this.service?.type_id // 次分類
    },
    processClient () {
      return process.client
    },
    isProductMode () {
      return this.service?.IsProductMode
    }
  },
  watch: {
    '$store.state.allServiceList' (val) {
      if (val.length > 0 && (!this.categoryName || this.categoryName === this.service.service_title)) {
        // 若無分類名稱
        this.categoryName = this.getCategoryName(this.category)
      }
    },
    redirection (val) {
      if (val !== null) {
        this.$nextTick()
          .then(this.listenTabSticky)
      }
    },
    typeId: {
      handler (value) {
        if ([158, 160].indexOf(value) > -1) {
          this.tabs[3].label = '常見問題'
        }
      },
      immediate: true
    },
    serviceItemId (value) {
      if (value) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
    },
    bannerList: {
      handler (value) {
        if (value.length > 1) {
          this.bannerSliderOptions.loop = true
        }
      },
      immediate: true
    }
  },
  async mounted () {
    await this.fetchServiceDateAndTime()
    this.isMobile = screen.width <= 768
    if (this.isCommunity) { // 社區模式
      await this.getCommunityList()
      this.checkCommunitySideNoteShow()
      this.$auth.$storage.watchState('loggedIn', async (loggedIn) => {
        if (loggedIn) {
          await this.getCommunityList()
        }
        this.checkCommunitySideNoteShow()
      })
    }
    if (this.isMobile) {
      this.footerShow = true
      const wrap = document.querySelector('body')
      wrap.addEventListener('touchmove', this.listenTouchmove)
      wrap.addEventListener('scroll', this.listenTouchmove)
    }
    if (!this.service) return
    this.$infobipTrackEvent('PageView', {
      page: '商品頁',
      serviceId: `${this.service.service_id}`,
      serviceTitle: this.service.service_title,
      serviceMainType: `${this.service.type_parent}`,
      serviceSubType: `${this.service.type_id}`
    })
  },
  methods: {
    loginSaveDataHandler () {
      const refKey = this.communitySideNoteShow ? 'groupServiceSideNote' : 'groupServiceItem'
      this.$refs[refKey]?.saveRouteAndSelectedData()
    },
    scrollToTab (tab) {
      this.$gaLogEvent('商品頁', `click_${tab.label}_${this.serviceName}_${this.serviceId}`)
      setTimeout(() => {
        const headerHeight = document.querySelector('#header').offsetHeight
        this.$vuetify.goTo('#service-tab', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      }, 100)
    },
    removeListenTabSticky () {
      if (this.redirection !== false || this.serviceIsNotAvaliable) return
      const observeElSelector = '.banner-list'
      this.observer.unobserve(document.querySelector(observeElSelector))
    },
    listenTabSticky () {
      // 非導購制才有tab區塊需監聽
      if (this.redirection !== false || this.serviceIsNotAvaliable) return
      const observeElSelector = '.banner-list'
      this.observer = new IntersectionObserver((entries) => {
        if (!document.querySelector('.fixed-tabs-bar .v-tabs-bar')) {
          return
        }
        document.querySelector('.fixed-tabs-bar .v-tabs-bar').classList.toggle('is-fixed', !entries[0].isIntersecting)
      })
      this.observer.observe(document.querySelector(observeElSelector))
    },
    getCategoryName (typeId) {
      const category = _.find(this.$store.state.service.allServiceList, { typeParent: parseInt(typeId) })
      return category ? category.mainTypeName : ''
    },
    listenTouchmove () {
      const ele = document.querySelector('#service-item')
      const eleOffsetTop = ele ? ele.offsetTop : 0
      const eleHeight = ele ? ele.offsetHeight : 0
      const scrollTop = window.scrollY
      const headerHeight = document.querySelector('#header').offsetHeight
      if (ele) {
        if (scrollTop + headerHeight >= eleOffsetTop) { // 已滑到指定位置
          this.footerShow = false
        }
        if (scrollTop + headerHeight < eleOffsetTop) {
          if (eleOffsetTop + eleHeight <= scrollTop) {
            // 如果預約項目區塊已全部顯示在畫面上
            this.footerShow = false
          } else {
            this.footerShow = true
          }
        }
      } else if (this.redirection) {
        // 導購
        this.footerShow = true
      }
    },
    async clickFooterBtn () {
      const headerHeight = document.querySelector('#header').offsetHeight
      const {
        ABirthday,
        AGender,
        APhone,
        AEmail,
        AName
      } = this.$auth.user || {}
      this.$FBConversionAPI({
        event_name: this.isProductMode ? '點擊立即訂購' : '點擊立即預約',
        user_data: {
          first_name: this.$auth.loggedIn ? AName : 'guest',
          date_birth: ABirthday || '',
          gender: AGender || '',
          phone: APhone || '',
          email: AEmail || ''
        },
        custom_data: {
          service_id: this.serviceId,
          content_name: this.serviceName
        }
      })
      if (this.redirection) {
        // 導購
        document.querySelector('.page-service.page .service-index .redirection .btn').click()
      } else {
        await this.$vuetify.goTo('#service-item', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
        this.listenTouchmove()
      }
    },
    async getCommunityList () {
      if (!this.$auth.loggedIn) {
        this.communityLoadDone = true
        return
      }
      if (this.communityList.length > 0) {
        this.communityLoadDone = true
        return
      }
      const communityList = await this.$store.dispatch('getPersonalCommunity')
      for (const community of communityList) {
        community.isDisabled = false
        community.showName = `${community.Community} ${community.TabletNote}`
        let city = community.City
        if (city.substring(0, 1) === '台') {
          city = '臺' + city.substring(1)
        }
        community.City = city
        const theCity = _.find(this.cityList, { MainName: city })
        if (!theCity) {
          community.isDisabled = true
        } else {
          const theArea = _.find(theCity.AreaList, { ParentName: community.Area })
          if (!theArea) {
            community.isDisabled = true
          }
        }
        let address = community.Address
        if (address.substring(0, 1) === '台') {
          address = '臺' + address.substring(1)
        }
        if (address.substring(0, city.length) === city) {
          address = address.replace(city, '')
        }
        if (address.substring(0, community.Area.length) === community.Area) {
          address = address.replace(community.Area, '')
        }
        community.showAddress = `${address} (${community.TabletNote})`
        this.communityList.push(community)
      }
      this.communityLoadDone = true
    },
    checkCommunitySideNoteShow () {
      let result = false
      if (!this.$auth.loggedIn) { // 未登入
        result = 'notLoggedIn'
      } else if (this.isCommunity && this.communityList.length === 0) { // 已登入，未有開通社區
        result = 'noCommunity'
      } else if (this.isCommunity) { // 已登入，開通社區未在服務範圍
        const canServiceCommunity = this.communityList.filter(community => !community.isDisabled)
        result = canServiceCommunity.length === 0 ? 'noServiceCommunity' : false
      }
      this.communitySideNoteShow = result
      console.log(this.communitySideNoteShow)
    },
    setOrderIsComplete (status) {
      this.orderIsComplete = status
    },
    refreshServiceItem () {
      this.serviceItemId++
    },
    transformScoreAmount (number) {
      if (number > 99) {
        return '99+'
      }
      return number
    },
    async fetchServiceDateAndTime() {
      if (this.redirection) return // 導購制，不用後續處理
      if (this.service?.serviceTimeType?.id === 9) return // 無日期與時間設定
      await this.$store.dispatch('service/getServiceDate', { id: this.serviceId })
      if ([1, 2, 9].indexOf(this.service?.serviceTimeType?.id) > -1) return // 無時間設定
      await this.$store.dispatch('service/getServiceTime', { id: this.serviceId })
    }
  }
}
</script>

<style lang="scss" scoped>
$mainBorderRadius: 20px;
::v-deep {
  .fixed-tabs-bar {
    .v-tabs-bar {
      position: sticky;
      top: $headerHeightMobile;
      padding-inline: 10px;
      z-index: 10;
      &.is-fixed {
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, .3)
      }
    }
    /** 手機以上 */
    @media screen and (min-width: $mobileWidth) {
      $borderRadius: 20px;
      .v-tabs-bar {
        top: $headerHeight;
      }
      .v-tabs-items.v-item-group {
        border-radius: 0 0 $borderRadius $borderRadius;
      }
    }
  }
  .page:not(.has-banner) {
    .fixed-tabs-bar .v-tabs-bar {
      border-top-left-radius: $mainBorderRadius;
      border-top-right-radius: $mainBorderRadius;
      overflow: hidden;
    }
  }
  .v-chip {
    margin-left: 3px;
    padding: 0 5px;
    color: $mainColor;
  }
}
@include empty-status-page;
.page-service {
  padding-top: 40px;
  padding-bottom: 40px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}
.bread-crumbs {
  margin-bottom: 30px;
  width: 100%;
  flex: none;
}
h1 {
  position: relative;
  flex: none;
  top: 0;
  left: 0;
  width: 100%;
  font-weight: bold;
  vertical-align: middle;
  &:before {
    content: '';
    background-color: $mainColor;
  }
}
.page {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;
  main {
    max-width: 620px;
    margin-left: var(--safe-area-inset-left);
  }
  &.has-side {
    main {
      flex: 6;
      max-width: $containerWidth;
    }
  }
  &.empty {
    align-items: center;
  }
  &:not(.has-side) {
    justify-content: center;
  }
}
#app .page-service.page {
  > .page > main > .tabs {
    ::v-deep {
      .v-slide-group__prev,
      .v-slide-group__next {
        display: none;
      }
    }
  }
}
.banner-list {
  .banner {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}
::v-deep {
  .tabs {
    .v-tabs-bar {
      height: auto;
      .v-tabs-bar__content {
        .v-tab {
          &:not(.v-tab--active) {
            color: #999999;
          }
        }
      }
      .tab {
        font-weight: bold;
        padding-left: 5px;
        padding-right: 5px;
        &.tab-active {
          color: $mainColor;
        }
      }
    }
  }
  .v-window__container {
    > div {
      img, video, iframe {
        max-width: 100%;
      }
      img {
        height: auto;
      }
    }
  }
}
.tabs {
  .tab {
    min-width: 60px;
    &:not(.v-tab--active) {
      color: #999999;
    }
  }
  .tab-content {
    padding: 38px 15px 45px;
  }
}
.side {
  margin-right: var(--safe-area-inset-right);
}
.footer-btn {
  display: none;
}
.loading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .page {
    display: block;
    padding-top: 0;
    .bread-crumbs {
      display: none;
    }
    &.empty {
      height: calc(100vh - #{$headerHeightMobile});
      display: flex;
      align-items: center;
    }
  }
  h1 {
    padding: 20px 10px;
    text-align: center;
    font-size: pxTorem(18px);
    line-height: pxTorem(24px);
    &:before {
      display: block;
      width: 50px;
      height: 5px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 8px;
    }
  }
  main {
    border-bottom: 15px solid #F2F2F2;
  }
  .side {
    padding: 20px 18px 35px;
    padding-left: calc(18px + var(--safe-area-inset-left));
    padding-right: calc(18px + var(--safe-area-inset-right));
  }
  .tabs {
    padding-left: var(--safe-area-inset-left);
    padding-right: var(--safe-area-inset-right);
    .tab {
      width: 25%;
      min-width: 0;
      padding: 10px 0;
      font-size: pxTorem(16px);
      line-height: pxTorem(21px);
    }
    .tab-content {
      padding-top: 25px;
      padding-bottom: 25px;
      padding-inline: 10px;
    }
  }
  ::v-deep {
    .v-slide-group__prev,
    .v-slide-group__next {
      min-width: 0;
      width: 0;
      flex: 0;
    }
    .v-tabs-slider-wrapper {
      height: 4px !important;
      width: 20% !important;
      padding-left: 5%;
    }
    .v-window__container {
      > div {
        > .content {
          // width: 70%;
          width: 100%;
          margin: 0 auto;
        }
      }
    }
  }
  .page-service.page {
    .footer-btn {
      position: fixed;
      display: block;
      bottom: 0;
      left: 0;
      width: 100%;
      height: auto;
      padding: 15px;
      padding-left: calc(15px + var(--safe-area-inset-left));
      padding-right: calc(15px + var(--safe-area-inset-right));
      padding-bottom: calc(15px + var(--safe-area-inset-bottom));
      opacity: 0;
      pointer-events: none;
      transition: opacity .3s;
      &.show {
        pointer-events: inherit;
        opacity: 1;
      }
      ::v-deep {
        span {
          font-size: pxTorem(16px);
          line-height: pxTorem(22px);
        }
      }
    }
  }
  .banner-list {
    width: 100%;
    height: auto;
    img {
      aspect-ratio: auto 2 / 1;
    }
  }
  .banner-loader {
    width: 100%;
    height: calc(100vw / 2);
    ::v-deep .v-skeleton-loader__image {
      height: 100%;
    }
  }
}

/** 手機以上 */
@media screen and (min-width: $mobileWidth) {
  .page {
    padding-left: 10px;
    padding-right: 10px;
  }
  h1 {
    margin-bottom: 23px;
    padding: 3px 10px;
    padding-right: calc(10px + var(--safe-area-inset-right));
    padding-left: 32px;
    padding-left: calc(32px + var(--safe-area-inset-left));
    font-size: pxTorem(21px);
    line-height: pxTorem(29px);
    &:before {
      position: absolute;
      left: 10px;
      left: calc(10px + var(--safe-area-inset-left));
      width: 6px;
      height: 100%;
    }
  }
  main {
    flex: 6;
    border-radius: $mainBorderRadius;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.3);
  }
  .banner-list {
    border-top-left-radius: $mainBorderRadius;
    border-top-right-radius: $mainBorderRadius;
    overflow: hidden;
    width: 100%;
    height: auto;
    img {
      aspect-ratio: auto 2 / 1;
    }
  }
  .banner-loader {
    border-top-left-radius: $mainBorderRadius;
    border-top-right-radius: $mainBorderRadius;
    height: calc(655px / 2);
    ::v-deep .v-skeleton-loader__image {
      height: 100%;
    }
  }
  .side {
    flex: 5;
    border-radius: 20px;
    max-width: 460px;
    margin-left: 45px;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.3);
    padding: 12px 15px 0px;
    &.loading {
      padding: 50px;
      text-align: center;
    }
  }
  .tabs {
    .tab {
      font-size: pxTorem(17px);
      line-height: pxTorem(24px);
      padding-top: 20px;
      padding-bottom: 13px;
    }
  }
  ::v-deep {
    .v-tabs-slider-wrapper {
      height: 7px !important;
      width: 20% !important;
      padding-left: 5%;
    }
    .v-window__container {
      > div {
        > .content {
          // width: 60%;
          width: 100%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
